var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.layout,
    {
      tag: "component",
      attrs: {
        favorites: _vm.favorites,
        currentLang: _vm.currentLang,
        menus: _vm.visibleMenus,
        customMenus: _vm.customMenus,
        customTabs: _vm.customTabs,
        menusActiveID: _vm.menusActiveID,
        panes: _vm.panes,
        panesHistory: _vm.panesHistory,
        activeKey: _vm.activeKey,
        unfold: _vm.unfold,
        subjectMode: _vm.subjectMode
      },
      on: {
        menuschange: _vm.handleMenusChange,
        menuchange: _vm.handleMenuChange,
        addcustommenu: _vm.handleCustomMenuAdd,
        removecustommenu: _vm.handleCustomMenuRemove,
        editcustommenu: _vm.handleCustomMenuEdit,
        menupushpin: _vm.handleMenuPushpin
      },
      scopedSlots: _vm._u([
        {
          key: "rightContentRender",
          fn: function() {
            return [
              _c("right-content", { attrs: { subjectMode: _vm.subjectMode } })
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm.$route.meta.routerView && ["home", "entry401"].includes(_vm.activeKey)
        ? _c("router-view")
        : _vm._e(),
      _vm._l(_vm.iframes, function(iframe) {
        return [
          _c("iframe", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: iframe.key === _vm.activeKey,
                expression: "iframe.key === activeKey"
              }
            ],
            key: iframe.key,
            attrs: {
              id: iframe.key,
              src: _vm.iframeUrl(iframe),
              width: "100%",
              height: "100%",
              frameborder: "0"
            }
          })
        ]
      }),
      _vm._l(
        _vm.microApps.filter(function(app) {
          return app.name
        }),
        function(app, index) {
          return [
            _c("div", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.$route.params.name === app.name,
                  expression: "$route.params.name === app.name"
                }
              ],
              key: index,
              attrs: {
                id:
                  _vm.serviceId +
                  "-" +
                  _vm.systemCode +
                  "-" +
                  app.name +
                  "-view-box"
              }
            })
          ]
        }
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: _vm.i18nRender("layouts.customscene", [
              _vm.customMenuFormData
                ? _vm.$t("layouts.edit")
                : _vm.$t("layouts.new")
            ]),
            width: "820px",
            wrapClassName: "custom-form",
            destroyOnClose: ""
          },
          model: {
            value: _vm.customMenuFormVisible,
            callback: function($$v) {
              _vm.customMenuFormVisible = $$v
            },
            expression: "customMenuFormVisible"
          }
        },
        [
          _c(
            "template",
            { slot: "footer" },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    float: "left",
                    color: "#252B3A",
                    "font-size": "12px",
                    "line-height": "32px"
                  }
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.i18nRender("form-modal.selected")) + " "
                  ),
                  _c("span", { staticStyle: { color: "#C7000B" } }, [
                    _vm._v(_vm._s(_vm.selectMenusLength))
                  ]),
                  _vm._v(
                    " " + _vm._s(_vm.i18nRender("form-modal.action")) + " "
                  )
                ]
              ),
              _c(
                "a-button",
                {
                  key: "cancel",
                  attrs: { disabled: _vm.loading },
                  on: { click: _vm.handleCustomMenuFormCancel }
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.i18nRender("form-modal.cancel")) + " "
                  )
                ]
              ),
              _c(
                "a-button",
                {
                  key: "submit",
                  attrs: { type: "primary", loading: _vm.loading },
                  on: { click: _vm.handleCustomMenuFormSubmit }
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.i18nRender("form-modal.submit")) + " "
                  )
                ]
              )
            ],
            1
          ),
          _c("custom-menu-form", {
            ref: "customMenuForm",
            attrs: {
              menus: _vm.visibleMenus,
              "form-data": _vm.customMenuFormData,
              "select-menus-length": _vm.selectMenusLength,
              currentLang: _vm.currentLang
            },
            on: {
              "update:selectMenusLength": function($event) {
                _vm.selectMenusLength = $event
              },
              "update:select-menus-length": function($event) {
                _vm.selectMenusLength = $event
              }
            }
          })
        ],
        2
      ),
      _vm.initPanesFlag ? _c("information-up") : _vm._e(),
      !_vm.ownStore && !_vm.isDemo ? _c("store-authorize-tip") : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }